import React from "react";
import PropTypes from "prop-types";

import DeletedEntriesDialog, { joinNames } from "../common/DeletedEntriesDialog";

/**
 * "Deleted entries" for Allergies — the shared audit dialog
 * (../common/DeletedEntriesDialog, px-matched to Figma 4065:3098) with this
 * section's three rows: Category / Reaction / Description.
 *
 * Soft-deleted allergies ride along on the same GET payload
 * (`deletedAllergies`), so there is no separate fetch.
 */

const getFields = (a) => [
  ["Category", a.category || "—"],
  ["Reaction", joinNames(a.reactions)],
  ["Description", (a.description && a.description.trim()) || "—"],
];

const DeletedEntriesModal = ({ patient, entries, onClose }) => (
  <DeletedEntriesDialog
    patient={patient}
    entries={entries}
    subtitle="Allergies"
    titleId="al3-del-title"
    getKey={(a) => a.allergyId}
    getTitle={(a) => a.name}
    getFields={getFields}
    onClose={onClose}
  />
);

DeletedEntriesModal.propTypes = {
  patient: PropTypes.object,
  entries: PropTypes.array,
  onClose: PropTypes.func.isRequired,
};

export default DeletedEntriesModal;
